import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-update-banner d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-4"
}
const _hoisted_2 = { class: "d-flex align-items-center gap-3" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showUpdateBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "app-update-banner__title" }, "Nova versão disponível"),
            _createElementVNode("div", { class: "app-update-banner__text" }, " Uma atualização do sistema foi encontrada. Atualize para carregar a versão mais recente. ")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissUpdateBanner && _ctx.dismissUpdateBanner(...args)))
            }, " Depois "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-warning",
              disabled: _ctx.updatingApp,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshApplication && _ctx.refreshApplication(...args)))
            }, _toDisplayString(_ctx.updatingApp ? "Atualizando..." : "Atualizar agora"), 9, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}